import { useEffect } from 'react';
import { useLocation } from 'react-router';


const PageViewTracker = () => {
    const location = useLocation();

    useEffect(() => {
        try {
            const pageURL = location.pathname + location.search;
            // todo: replace with GTM
            //ReactGA.send({ hitType: "pageview", pageURL });
        } catch (err) {
            console.log(err);
        }
    }, [location]);

    return null;
};

export default PageViewTracker;